import * as z from "zod";
import { dropoffProviderType } from "../dropoff-provider";
import {
  RETURN_RATE_SOURCE_TYPE,
  type ReturnRateSourceSelection,
} from "./return-rate-source-selection";

export const ReturnRateSourceSelectionSchema: z.ZodType<ReturnRateSourceSelection> =
  z.object({
    sources: z.array(
      z.discriminatedUnion("type", [
        z.object({ type: z.literal(RETURN_RATE_SOURCE_TYPE.REDO_RATES) }),
        z.object({
          type: z.literal(RETURN_RATE_SOURCE_TYPE.MERCHANT_CARRIER_ACCOUNTS),
        }),
        z.object({
          type: z.literal(RETURN_RATE_SOURCE_TYPE.MERCHANT_CARRIER_ACCOUNT),
          carrierAccountId: z.string(),
          deniedServiceLevels: z.array(z.string()).optional(),
        }),
        z.object({
          type: z.literal(RETURN_RATE_SOURCE_TYPE.DROPOFF_PROVIDER),
          provider: z.enum(dropoffProviderType),
        }),
      ]),
    ),
  });

export function safeParseReturnRateSourceSelection(
  value: unknown,
): ReturnRateSourceSelection | undefined {
  if (value == null) {
    return undefined;
  }

  const result = ReturnRateSourceSelectionSchema.safeParse(value);
  return result.success ? result.data : undefined;
}
